export var MobileNumberCheckStatus;
(function (MobileNumberCheckStatus) {
    MobileNumberCheckStatus["QUEUED"] = "queued";
    MobileNumberCheckStatus["IN_PROGRESS"] = "in_progress";
    /** Kept for a short while after a failure so the client can show it. A new check can be started over it */
    MobileNumberCheckStatus["FAILED"] = "failed";
})(MobileNumberCheckStatus || (MobileNumberCheckStatus = {}));
/** Identifies what an AI fix run covers: `` for the whole organisation, otherwise the sorted contact ids */
export function mobileNumberFixScope(contactIds) {
    return [...new Set(contactIds || [])].sort((a, b) => a - b).join(`,`);
}
/** Contacts that can be approved in one apply request, each is a round trip to the accounting system */
export const MOBILE_NUMBER_FIX_MAX_CONTACTS = 5;
//# sourceMappingURL=mobileNumberCheck.js.map